export type DeleteUserRequest = {
  userId: string;
};

export type DeleteUserResponse = {
  success: true;
};

export const deletedUserName = "(User Deleted)" as const;
